const routes = [
  {
    path: '/:domain',
    component: () => import('@/views/agent/agent.vue'),
  },
]

export default routes
